import r from"react";import{SessionProvider as s}from"next-auth/react";function t({children:e,session:o}){return r.createElement(s,{session:o,refetchInterval:3600,refetchOnWindowFocus:!0},e)}export{t as a};
